import { useState } from 'react';
import CustomSelect from '../../../../components/Select/Select';
import { locationCategoryList, locationTypesWOConsum } from '../../../../util/dropList';
import ExpiryRisk from './ExpiryRisk';
import LowStockAlerts from './LowStockAlerts';
import PriceAndMarginWatch from './PriceAndMarginWatch';
import StockByCategory from './StockByCategory';
import StockDashboard from './StockDashboard';
import Stockbar from './Stockbar';
import SummaryCards from './SummaryCards';

const comStyle = {
  flex: 1,
  backgroundColor: "#ffffff",
  borderRadius: "12px",
  padding: "24px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
  border: "1px solid #e5e7eb",
}

function Main2() {
  const [filterValues, setFilterValues] = useState({ locationType: null, storageType: null })

  return (
    <div className="App2">
      <div className='flex1-end'>
        <div className='w15Per'>
          <CustomSelect
            list={locationTypesWOConsum}
            value={filterValues?.locationType}
            label=""
            handleChange={(e) =>
              setFilterValues({ ...filterValues, locationType: e?.target?.value })
            }
            select
          />
        </div>
        {filterValues?.locationType === 'Storage' ?
          <div className='w15Per ml20'>
            <CustomSelect
              list={locationCategoryList}
              value={filterValues?.storageType}
              label=""
              handleChange={(e) =>
                setFilterValues({ ...filterValues, storageType: e?.target?.value })
              }
              select
            />
          </div> : null
        }
      </div>
      <div style={{ padding: '30px', background: '#f8f9fb' }}>
        <SummaryCards />
        <div
          style={comStyle}
          className='mt30'
        >
          <StockByCategory />
        </div>

        <div style={{ padding: '30px 0px', background: '#f9fafc', }}>
          <LowStockAlerts />
        </div>
        <div
          style={comStyle}
          className='mt30'
        >
          <ExpiryRisk />
        </div>
        <div style={{ padding: '30px 0px', background: '#f9fafc', }}>
          <StockDashboard />

        </div>
        <div style={{ padding: '0px', background: '#f9fafc', }}>
          <Stockbar />

        </div>

        {/* <div style={{ padding: '30px 0px', background: '#f9fafc', }}>
          <SalesPurchasesReturns />
        </div> */}
        <PriceAndMarginWatch />
      </div>

    </div>
  );
}

export default Main2;
